import { MenuItem, Select, FormControl, InputLabel } from "@mui/material";
import { useAepsBank } from "../hooks/useAepsBank";

const AepsPipeSelect = () => {
  const { banks, selectedBank, changeBank } = useAepsBank();

  return (
    <FormControl fullWidth size="small" className="mb-2">
      <InputLabel sx={{ fontSize: "12px" }}>AEPS Bank Pipe</InputLabel>

      <Select
        value={selectedBank}
        label="AEPS Bank Pipe"
        onChange={(e) => changeBank(e.target.value)}
        sx={{
          fontSize: "12px",
          fontWeight: 500,
          borderRadius: "5px",
          backgroundColor: "#f9fafb",
          "& .MuiSelect-select": {
            padding: "8px 12px",
          },
        }}
      >
        {Object.keys(banks).map((b) => (
          <MenuItem
            key={b}
            value={b}
            sx={{ fontSize: "12px", fontWeight: 500 }}
          >
            {b.toUpperCase()}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default AepsPipeSelect;
